import React from 'react'
import { selectIsAuthenticated } from '../../../modules/auth/selectors'
import { useSelector } from '../../../react-redux'

import View from '../components/TeamList'

const TeamPage = ({ teamName }: { teamName: string }) => {
  const team = useSelector(state => state.team[teamName])
  const members = team ? team.members : []
  const isAuthenticated = useSelector(selectIsAuthenticated)

  return (
    <View
      isLoading={!team || team.fetchingList}
      teamList={members}
      teamName={teamName}
      isAuthenticated={isAuthenticated}
    />
  )
}

export default TeamPage
